import { Button, List, Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { InferenceFile, TableResult } from '../../types';
import { Label } from '../../types/label';
import { SingleTable } from './SingleTable';
import { MultiflowValidationResult } from '../../types/flow';

type Props = {
  hoveredLabel: null | Label;
  onLabelValueMouseEnter: any;
  onLabelValueMouseLeave: any;
  inferenceFile: null | InferenceFile;
  multiValidationResult: null | MultiflowValidationResult;
};

export const ResultTablesGeneric = ({
  inferenceFile,
  hoveredLabel,
  onLabelValueMouseEnter,
  onLabelValueMouseLeave,
  multiValidationResult,
}: Props) => {
  const [tableModalVisible, setTableModalVisible] = useState<boolean>(false);
  const [selectedTable, setSelectedTable] = useState<TableResult | null>(null);
  const [theHeight, setTheHeight] = useState<number>(0);
  const modalBodyRef = useRef<HTMLDivElement>(null);

  const isMultiflow = () => {
    return (
      inferenceFile && inferenceFile.model && inferenceFile.model.algorithm && inferenceFile.model.algorithm.multiflow
    );
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    handleWindowResize();
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [tableModalVisible]);

  const handleWindowResize = () => {
    if (!modalBodyRef.current) return;
    const maxHeight = window.innerHeight * 0.8;
    setTheHeight(maxHeight);
    modalBodyRef.current.style.maxHeight = `${maxHeight}px`;
  };

  const selectTable = (table: TableResult) => {
    setSelectedTable(table);
    setTableModalVisible(true);
    handleWindowResize();
  };

  const closeModal = () => {
    setSelectedTable(null);
    setTableModalVisible(false);
  };

  return (
    <>
      <List
        itemLayout="horizontal"
        dataSource={inferenceFile?.inferenceResult?.result.tables}
        className="hover-highlight-list"
        renderItem={(table: TableResult) => (
          <List.Item
            onClick={() => selectTable(table)}
            style={{
              cursor: 'pointer',
              padding: '16px',
            }}>
            <List.Item.Meta title={<span>{table.name}</span>} />
          </List.Item>
        )}
      />
      <Modal
        visible={tableModalVisible}
        onCancel={closeModal}
        width={1000}
        style={{ top: 10 }}
        footer={[
          <Button key="back" onClick={closeModal}>
            Close
          </Button>,
        ]}>
        <div ref={modalBodyRef}>
          <SingleTable
            table={selectedTable}
            maxHeight={theHeight}
            isMultiflow={isMultiflow}
            multiValidationResult={multiValidationResult}
          />
        </div>
      </Modal>
    </>
  );
};
